import { useIntl } from "react-intl";
import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { ImageTypes } from "~enums/imageTypes.ts";
import { EntityGroupTableColumns } from "~pages/EntityGroups/EntityGroupListPage/enums/entityGroupTableColumns.ts";
import type { EntityGroup } from "~types/entityGroup.ts";
import type { Image } from "~types/image.ts";
import { sortStringValues } from "~utils/utilities.ts";

export const useGetEntityGroupTableColumns = (): Array<DataTableColumn<EntityGroup>> => {
  const { formatMessage } = useIntl();

  return [
    {
      key: EntityGroupTableColumns.Logo,
      title: formatMessage({ id: "entityGroups.table.column.logo" }),
      dataIndex: "images",
      width: 25,
      render: (value: Array<Image>) => <DataTableImageColumn images={value} imageTypes={[ImageTypes.Logo]} />,
    },
    {
      key: EntityGroupTableColumns.EntityGroupId,
      title: formatMessage({ id: "entityGroups.table.column.entityGroupId" }),
      dataIndex: "entityGroupId",
      width: 300,
    },
    {
      key: EntityGroupTableColumns.ExternalId,
      title: formatMessage({ id: "entityGroups.table.column.externalId" }),
      dataIndex: "externalId",
      width: 150,
    },
    {
      key: EntityGroupTableColumns.CodeLatin,
      title: formatMessage({ id: "entityGroups.table.column.codeLatin" }),
      dataIndex: "codeLatin",
      width: 90,
    },
    {
      key: EntityGroupTableColumns.CodeLocal,
      title: formatMessage({ id: "entityGroups.table.column.codeLocal" }),
      dataIndex: "codeLocal",
      width: 90,
    },
    {
      key: EntityGroupTableColumns.NameFullLocal,
      title: formatMessage({ id: "entityGroups.table.column.nameFullLocal" }),
      dataIndex: "nameFullLocal",
      sorter: (a, b) => sortStringValues(a.nameFullLocal, b.nameFullLocal),
    },
    {
      key: EntityGroupTableColumns.NameFullLatin,
      title: formatMessage({ id: "entityGroups.table.column.nameFullLatin" }),
      dataIndex: "nameFullLatin",
      width: 150,
      sorter: (a, b) => sortStringValues(a.nameFullLatin, b.nameFullLatin),
    },
    {
      key: EntityGroupTableColumns.InternationalReference,
      title: formatMessage({ id: "entityGroups.table.column.internationalReference" }),
      dataIndex: "internationalReference",
      width: 90,
    },
    {
      key: EntityGroupTableColumns.Status,
      title: formatMessage({ id: "entityGroups.table.column.status" }),
      dataIndex: "status",
      width: 90,
    },
  ];
};
